import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const cvPackageCheckoutPage = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
        },
        leftWrapper: {},
        rightWrapper: {},
        title: {
            fontSize: "6.04vw",
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            marginRight: "6.04vw"
        },
        backButton: {
            wrapper: {
                display: "flex",
                alignItems: "center",
                marginLeft: "3.98vw",
                marginTop: "3vw",
            },
            button: {
                width: "8.08vw",
                height: "8.08vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "50%"
            },
            icon: {
                fill: Color.MiddleBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "2.04vw",
                fontSize: "3.86vw",                
                fontWeight: "bold",
                color: Color.Black
            }
        },
        blue: {
            color: Color.Blue
        },
        packages: {
            margin: "2.40vw 4.83vw 0 4.83vw",
            subTitle: {
                fontSize: "3.86vw",
                color: Color.SharpAsh,
                fontWeight: "bold"
            },
            title: {
                fontSize: "7.24vw",
                fontWeight: "bold",
                marginTop: "2.41vw",
                color: Color.DeepBlack
            },
            card: {
                width: "99%",
                backgroundColor: Color.LightBlue,
                borderRadius: "4.83vw",
                textAlign: "-webkit-center",
                margin: "7.24vw 0.5% 9.66vw 0.5%",
                height: "200vw",
                popular: {
                    marginBottom: "4.59vw"
                }
            },
            popular: {
                height: "8.99vw",
                lineHeight: "8.99vw",
                borderRadius: "4.83vw 4.83vw 0 0",
                backgroundColor: Color.Red,
                color: Color.White,
                fontSize: "3.86vw"
            },
            price: {
                paddingTop: "1.08vw",
                paddingBottom: "3.08vw",
                fontWeight: 700,
                fontSize: "5.80vw",
                color: Color.Blue,
                position: "relative",
                textAlign: "center"
            },
            cvLimit: {
                paddingTop: "3.08vw",
                margin: "2.66vw 0 4.83vw 0",
                fontWeight: 700,
                fontSize: "10.87vw",
                color: Color.DeepBlack
            },
            featureEnable: {
                width: "70.77vw",
                fontFamily: Font.Poppins,
                fontWeight: 600,
                fontSize: "3.62vw",
                color: Color.LightBlack,
                textAlign: "center",
                marginBottom: "2.41vw"
            },
            featureDisable: {
                fontWeight: 400,
                color: Color.MiddleBlack,
                textDecorationLine: "line-through"
            },
            button: {
                height: "12.08vw",
                width: "66.18vw",
                borderRadius: "2.41vw",
                backgroundColor: Color.Blue,
                color: Color.White,
                fontSize: "4.35vw",
                fontWeight: 700,
                position: "absolute",
                bottom: 13,
                marginLeft: "-32vw"
            },
            selectedButton: {
                height: "12.08vw",
                width: "66.18vw",
                backgroundColor: Color.Ash,
                color: Color.SharpAsh,
                fontWeight: "bold" as "bold",
                fontSize: "4.35vw",
                borderRadius: "2.41vw",
                position: "absolute",
                bottom: 13,
                marginLeft: "-32vw"
            },
            packageTypeButton: {
                display: "flex",
                alignItems: "center",
                marginTop: "7.24vw",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",   
                color: Color.SharpAsh,
                cvBased: { 
                    marginLeft: "12.6vw",
                    marginRight: "7.24vw"
                },
                unlimited: {
                    marginLeft: "7.24vw"
                }
            },
            toggleButton: {
                switch: {
                    border: "solid 3px "+ Color.Green,
                    marginLeft: "unset",
                    backgroundColor: Color.White,
                    checked: {
                        backgroundColor: Color.White
                    }
                },
                switchCircle: {
                    backgroundColor: Color.Green,
                    checked: {
                        backgroundColor: Color.Green
                    }
                }
            },
            chevronLeftIcon: {
                height: "7.24vw",
                width: "4.34vw",
                position: "absolute",
                marginTop: "0",
                left: "0",
                marginLeft: "2.89vw"
            },
            chevronRightIcon: {
                height: "7.24vw",
                width: "4.34vw",
                position: "absolute",
                marginTop: "0",
                right: "0",
                marginRight: "2.89vw" 
            },
            annualChevronRightIcon: {
                marginTop: "0"
            }
        },
        subscription: {
            marginTop: "25vw",
            title: {
                color: Color.LightBlack,
                marginLeft: "4.83vw",
                fontSize: "7.24vw",
                fontWeight: "bold"
            },
            packageWrapper: {
                display: 'flex',
                flexDirection: 'column'
            },
            monthWrapper: {
                display: 'flex',
                alignItems: 'center',
                width: "85vw",
                height: "14vw",
                borderRadius: "2vw",
                border: "2px solid" + Color.DarkAsh,
                margin: "6vw auto 0"
            },
            unlimited: {
                fontSize: '4.34vw',
                width: "35vw",
                marginLeft: "2vw"
            },
            monthsCountSelect: {
                marginLeft: "auto",                
                marginTop: "unset",
                buttonWrapper: { 
                    width: "10.58vw"
                },
                button: {
                    width: "auto",
                    marginLeft: "auto"
                },
                hover: {
                    width: "10.58vw"
                }
            },
            priceWrapper: {
                display: "flex",
                marginLeft: "auto",
                marginRight: "4vw",
                alignItems: "center"
            },
            price: {
                fontSize: '4.34vw',
                fontWeight: 'bold',
                marginLeft: "4vw",
                color: Color.SharpAsh
            },
            closeButton: {
                width: "4vw",
                fill: Color.MiddleAsh,
                marginLeft: "2vw",
                cursor: "pointer",
                overflow: "visible"
            },
            promoWrapper: {
                height: "21.10vw",
                width: "77vw",
                borderRadius: "2.41vw",
                border: "0.24vw solid " + Color.Gainsboro,
                padding: "4.83vw",
                margin: "4.83vw auto 0"
            },
            promoCode: {
                display: "flex",
                flexDirection: "column" as "column"       
            },
            subTitle: {
                fontSize: '4.34vw',
                color: Color.DeepBlack,
                fontWeight: "bold",
                marginTop: "2vw"
            },
            inputWrapper: {
                display: 'flex',
                flexDirection: "row",
                height: "16vw",
                alignItems: "center"
            },
            inputCode: {
                height: "12.07vw",
                margin: "unset",
                borderRadius: "2.41vw"
            },
            promoInvalid: {
                height: "24.80vw",
                border: "0.24vw solid " + Color.Red,
                backgroundColor: Color.Linen
            },
            promoInvalidMessage: {
                fontSize: "3.38vw",
                color: Color.Red
            },
            button: {
                color: Color.Blue,
                borderRadius: '1vw',
                fontSize: '4.83vw',
                border: "2px solid" + Color.Blue,
                height: "10vw",
                width: '20vw',
                marginLeft: "2.17vw",
                marginRight: "4vw",
                fontWeight: "bold",
                applied: {
                    width: '23vw',
                    color: Color.DeepAsh,
                    border: "0.48px solid" + Color.DeepAsh
                }
            }
        },
        emptyCart: {
            width: "85vw",
            height: "12vw",
            margin: "6vw auto 0"
        },
        checkout: {
            width: "85vw",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "30vw",
            line: {
                border: "none",
                height: "0.22vh",
                backgroundColor: Color.Gainsboro,
                margin: "8.82vw 0 4.95vw 0"
            },
            priceRow: {
                display: "flex" as "flex",
                fontSize: "4.35vw",
                alignItems: "center" as "center",
                marginLeft: "4vw"
            },
            priceValue: {                    
                fontSize: "6.76vw",
                fontWeight: "bold" as "bold",
                marginLeft: "auto",
                marginRight: "4vw"
            },
            policyLabel: {
                marginLeft: "1.21vw"
            },
            sharpText: {
                fontSize: "3.14vw",            
                color: Color.SharpAsh,
                black: {                
                    fontWeight: "bold",
                    color: Color.DeepBlack,
                    cursor: "pointer",
                    textDecoration: "none",
                    marginLeft: "1vw"
                }
            },
            redText: {
                color: Color.Red
            },
            checkoutButton: {
                width: "100%",
                height: "5.58vh",
                border: "none",
                color: Color.White,
                background: Color.Green,
                fontWeight: "bold" as "bold",
                fontSize: "4.35vw",
                borderRadius: "2.41vw",
                marginTop: "3.2vw"
            },
            orLable: {
                display: "flex",
                width: "100%",
                justifyContent: "center",
                marginTop: "2vw",
                fontSize: "4.35vw",
                color: Color.DeepAsh,
                fontWeight: "500vw"
            },
            depositButton: {
                width: "100%",
                height: "5.58vh",
                border: "2px solid"+ Color.Blue,
                color: Color.Black,
                fontWeight: "bold" as "bold",
                fontSize: "4.35vw",
                borderRadius: "2.41vw",
                marginTop: "3.2vw"
            },
            iconGride: {
                display: "flex",
                justifyContent: "center",
                margin: "3.57vh 0"
            },
            paymentIcon: {
                maxWidth: "17.21vw",
                maxHeight: "5.83vw",
                margin: "0 1.93vw 0 0",
                WebkitFilter: "grayscale(1)", 
                filter: "grayscale(1)"
            }
        },
        checkbox: { },
        dialog: {            
            container: {                
                width: "70vw",
                height: "auto",
                padding: "7.48vw  14.5vw",
                borderRadius: "3vw 3vw 0 0"
            },
            closeButton: {
                width: "4.58vw",
                height: "4.58vw",
                top: "3.41vw",
                right: "5.70vw"
            }                      
        },
        dialogTitle: {
            margin: 0,
            fontSize: "4.35vw",
            marginLeft: "-8vw",
            fontWeight: "bold",
            color: Color.Black
        },
        dialogMessage: {
            margin: "4.83vw 0 0 -8vw",
            fontSize: "3.86vw",
            color: Color.Black,
            lineHeight: "5vw",
            fontWeight: 700
        },
        messageList: {
            marginTop: "0.6vw",
            userSelect: "text"
        },
        footer: {
            margin: "0 0 0 -8vw",
            fontSize: "3.86vw",
            color: Color.Red,
            fontWeight: 700,
            textAlign: "center",
            userSelect: "text"
        },
        termsConditions: {
            textAlign: "center",
            color: Color.MiddleBlack,
            fontWeight: 500, 
            marginTop: "3vw"
        },
        dotsWrapper: {
            marginLeft: "-3.96vw"
        },
        inputContainer: {
            marginTop: "2.23vh",
            color: Color.DeepAsh
        },
        textInput: {
            height: "12.08vw",
            fontSize: "3.86vw",
            fontFamily: Font.Poppins,
            marginTop: "1.67vh"
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw"
        },        
        leftWrapper: {},
        rightWrapper: {
            width: "100%",
            paddingLeft: "2.32vw"
        },
        buttonWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            height: "4.68vw",
            justifyContent: "space-between",
            marginBottom: "2vw"
        },
        backButton: {            
            wrapper: {
                display: "block",
                alignSelf: "center",
                marginLeft: "unset",
                marginTop: "unset",
                width: "7vw"                 
            },
            container: {
                display: "flex",
                alignItems: "center"
            },
            button: {
                paddingTop: "0.3vw",
                backgroundColor: Color.Ash, 
                width: "2.60vw",
                height: "2.60vw",
                borderRadius: "50%"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "1.3vw",
                fontSize: " 0.93vw",
                fontWeight: 'bold',
                color: Color.LightBlack
            }          
        },
        title: {
            fontSize: "2.60vw"
        },
        packages: {
            margin: "1.9vw 0 0 0",
            subTitle: {
                color: Color.LightBlack,
                fontSize: "1.56vw"
            },
            title: {
                fontSize: "2.86vw",                
                marginTop: "1.04vw",
                width: "51.51vw"
            },
            table: {
                marginTop: "3.78vw",
                borderSpacing: "0",
                firstRow: {
                    height: "5vw"
                },
                lastRow: {
                    boxShadow: "0px 0px 0px 1px #0000001A",
                    borderRadius: "0 0 0.52vw 0.52vw"
                }
            },
            included: {
                width: "16.32vw"
            },
            tableHead: {
                width: "16.32vw",
                height: "9vw",
                borderLeft: "1px solid" + Color.MiddleAsh,
                hovered: {
                    backgroundColor: Color.White,
                    boxShadow: "0px 0px 0px 1px #0000001A",
                    borderRadius: "0.52vw 0.52vw 0 0"
                },
                nextColumnHovered: {
                    borderLeft: "1px solid transparent"
                },
                prevColumnHovered: {
                    borderRight: "1px solid transparent"
                }
            },
            headBorderBlack: {
                borderLeft: "2px solid" + Color.Black,
                borderRight: "2px solid" + Color.Black
            },
            body: {
                borderTop: "1px solid" + Color.MiddleAsh
            },
            bodyBorderBlack: {
                borderLeft: "2px solid" + Color.Black,
                borderRight: "2px solid" + Color.Black
            },
            tableHeading: {
                display: "block",
                width: "6.41vw",
                fontWeight: 700,
                fontSize: "1.56vw",
                color: Color.LightBlack,
                textAlign: "left"
            },
            popular: { 
                height: "2.3vw",
                lineHeight: "2.3vw",
                borderRadius: "none",
                backgroundColor: Color.Black,
                color: Color.White,
                fontSize: "0.94vw",
                margin: "0 -0.2vw -0.2vw -0.1vw"
            },
            price: {
                paddingTop: "0.91vw",                
                paddingBottom: "0",
                marginBottom: "1.8vw",
                fontSize: "1.04vw",
                color: Color.Black                
            },
            annualPackageName: {
                fontSize: "1.04vw"
            },
            textBlue: {
                color: Color.Blue
            },
            textRed: {
                color: Color.Red   
            },
            unlimitedCVPrice: {
                fontSize: "1.04vw",
                marginBottom: "1vw"
            },
            lkr: { 
                fontWeight: 700,
                fontSize: "1.04vw",
                color: Color.Black
            },
            cvLimit: {
                paddingTop: "0",
                margin: "0.5vw 0 0vw 0",                
                fontSize: "1.6vw", 
                color: Color.SharpAsh
            },
            featureEnable: {
                display: "block",
                width: "11.77vw",                
                fontWeight: 500,
                fontSize: "0.94vw",
                color: Color.SharpAsh,
                textAlign: "left",
                margin: "0.44vw 0"
            },
            twoJobsPosting: {
                display: "inline",
                width: "auto",
                marginRight: "0.4vw"
            },
            twoJobsPostingWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%"
            },
            cellWrapper: {
                textAlign: "center",
                borderLeft: "1px solid" + Color.MiddleAsh,
                borderTop: "1px solid" + Color.MiddleAsh,
                hovered: {
                    backgroundColor: Color.White,
                    boxShadow: "0px 0px 0px 1px #0000001A"
                },
                nextColumnHovered: {
                    borderLeft: "1px solid transparent"
                },
                prevColumnHovered: {
                    borderRight: "1px solid transparent"
                }
            },
            enableIcon: {
                height: "1.3vw",
                width: "1.3vw",
                overflow: "visible",
                marginTop: "0.3vw"
            },
            button: {
                height: "2.19vw",
                width: "12.50vw",
                borderRadius: "0.52vw",                
                margin: "0 0 0 -6.2vw",                
                fontSize: "0.83vw",
                bottom: "none"                
            },
            unlimitedCVButton: {
                marginTop: "-0.5vw",
            },
            annualCVButton: {
                marginTop: "0.5vw",
            },
            selectedButton: {
                height: "2.19vw",
                width: "12.50vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                margin: "0 0 0 -6.2vw",
                bottom: "none"
            },
            packageTypeButton: {
                position: "absolute",
                marginTop: "-1.5vw",
                fontSize: "1.04vw",
                fontWeight: "Regular",  
                color: Color.DeepAsh,
                cvBased: {
                    marginLeft: "58.7vw",
                    marginRight: "1.56vw"
                },
                unlimited: {
                    marginLeft: "1.56vw"
                }
            },
            toggleButton: {
                switch: {
                    height: "1.87vw",
                    width: "3.22vw"
                },
                switchCircle: {
                    margin: "0.15vw 0.08vw auto",
                    height: "1.55vw",
                    width: "1.55vw",
                }
            },
            disableIcon: {
                height: "1.6vw",
                width: "1.6vw",
                overflow: "visible",
                marginTop: "0.3vw"
            },
            selectedPackage: {
                backgroundColor: Color.LightGray,
                boxShadow: "0px 0px 0px 1px #0000001A"
            }
        },
        subscription: {
            marginTop: "5vw",
            title: {
                marginLeft: 0,
                fontSize: "2.08vw"
            },
            packageWrapper: {
                flexDirection: 'row'
            },
            monthWrapper: {
                width: "34vw",
                height: "5vw",
                borderRadius: "1.04vw",
                margin: "1vw 0 0"
            },
            unlimited: {
                fontSize: '1.04vw',
                width: "auto",
                fontWeight: 'bold',
                marginLeft: "1vw"
            },
            monthsCountSelect: {
                marginBottom: "unset",
                marginLeft: "unset",
                buttonWrapper: { 
                    width: "4.06vw"
                },
                button: {
                    height: "1.82vw",
                    marginLeft: "9.04vw"
                },
                hover: {
                    width: "4.06vw"
                }
            },
            priceWrapper: {
                marginRight: "1vw",
                alignItems: "center"
            },
            price: {
                fontSize: '1.04vw',
                fontWeight: 'bold',
                marginLeft: "0.5vw",
                marginRight: "1.5vw"
            },
            closeButton: {
                width: "1vw",
                marginLeft: "auto",
                marginRight: "1vw"
            },
            promoWrapper: {
                height: "unset",
                width: "34vw",
                border: "2px solid " + Color.Gainsboro,
                borderRadius: "1.04vw",
                padding: "1vw 1.66vw 0 1.82vw",
                alignItems: "center" as "center",
                marginTop: "1vw"
            },
            promoCode: {
                flexDirection: "row" as "row"          
            },
            subTitle: {
                fontSize: '1.04vw',
                marginLeft: "1vw",
                width: "7vw",
                marginTop: 0
            },
            promoTitle: {
                width: "6.6vw",
                marginLeft: "unset",
                height: "2.86vw"
            },
            inputWrapper: {
                display: 'flex',
                flexDirection: "row",
                alignItems: "center",
                height: "3vw"
            },
            inputCode: {
                width: '18vw',
                borderRadius: '0.52vw',
                backgroundColor: Color.Ash,
                border: "1vw",
                marginLeft: "1.5vw",
                marginRight: "0.85vw",
                height: "2.5vw"
            },
            promoInvalid: {
                height: "auto",
                border: "0.05vw solid " + Color.Red
            },
            promoInvalidMessage: {
                fontSize: "0.94vw",
                marginLeft: "11.50vw"
            },
            button: {
                borderRadius: '0.52vw',
                fontSize: '1.04vw',
                height: "2.5vw",
                width: '5vw',
                marginLeft: "unset",
                marginRight: "1vw",
                applied: {
                    width: 'unset',
                    border: "0.15vw solid " + Color.DeepAsh,
                    margin: "auto 0 auto 0"
                }
            }
        },
        emptyCart: {
            width: "36vw",
            height: "5vw",
            margin: "1vw 0 0"
        },
        checkout: {
            width: "35vw",
            marginLeft: 0,
            marginBottom: "10vw",
            line: {
                height: "0.18vh",
                margin: "5.90vh 0 3.9vh"
            },
            priceRow: {
                fontSize: "0.94vw",
                marginLeft: 0
            },
            priceValue: {                    
                fontSize: "1.46vw",
                marginRight: 0
            },
            policyLabel: {
                marginLeft: "0.52vw",
                borderRadius: "5px"
            },
            sharpText: {
                fontSize: "0.83vw",
                marginTop: "2.77vh",
                borderRadius: "0.52vw",
                black: {
                    marginLeft: "0.325vw"
                }
            },
            checkoutButton: {
                height: "2.60vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                marginTop: "1.15vw"
            },
            orLable: {
                marginTop: "0.8vw",
                fontSize: "1.04vw"
            },
            depositButton: {
                height: "2.60vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                marginTop: "1.15vw"
            },
            iconGride: {
                margin: "1.66vw 0 0 0"
            },
            paymentIcon: {
                maxWidth: "5.10vw",
                maxHeight: "1.51vw",
                margin: "0 0.83vw 0 0"
            }
        },
        checkboxInput: {
            checkbox: {
                margin: "0.2vw 0.52vw 0 0",
                lineHeight: "1.5vw"
            },
            customCheckBoxContainer: {
                lineHeight: "1.5vw"
            },
        },
        dialog: {            
            container: {                
                width: "50vw",
                maxHeight: "316.61vw",
                padding: "2.48vw 2.12vw",
                borderRadius: "0.52vw"
            },
            closeButton: {
                width: "1.59vw",
                height: "1.59vw",
                top: "0.90vw",
                right: "0.90vw"
            }                    
        },
        dialogTitle: {
            margin: 0,
            fontSize: "1.34vw",
            marginLeft: "0",
            marginTop: "1.5vw",
            textAlign: "center"
        },
        dialogMessage: {
            margin: "1.51vw 0 0 0",
            fontSize: "1.04vw",
            lineHeight: "1.2vw",
            fontWeight: "500",
            textAlign: "center"
        },
        footer: {
            fontSize: "1.04vw",
            textAlign: "center",
            marginLeft: "0",
            marginTop: "1.5vw"
        },
        termsConditions: {
            margin: "1.2vw 0"
        },
        inputContainer: {
            marginTop: "1.30vw",
            width: "100%"
        },
        textInput: {
            height: "3.65vw",
            fontSize: "0.93vw",
            paddingLeft: "1.56vw",
            marginTop: "1.85vh"
        }
    }
}